export default {
  enableCart: true,
  enableAccount: true,
};
